export enum BusinessUnitKey {
  Flokee = 'FLOKEE',
  Cleepo = 'CLEEPO',
}

export const DEFAULT_DASHBOARD_ROUTE_NAME = 'DashboardView';
export const DEFAULT_LOGIN_ROUTE_NAME = 'AuthLoginView';
export const DEFAULT_SELECT_ACCOUNT_ROUTE_NAME = 'SelectAccountView';
export const DEFAULT_INVEST_ROUTE_NAME = 'InvestView';

export interface BusinessUnitConfig {
  key: BusinessUnitKey;
  label: string;
  // Route prefix for this BU namespace (e.g. /flokee).
  basePath: string;
  // Production domain that implies this BU.
  domain?: string;
  // Route name to redirect authenticated users to this BU dashboard.
  dashboardRouteName: string;
  // Route name to redirect unauthenticated users to this BU login.
  loginRouteName: string;
  // Route name for account/order switcher view in this BU.
  selectAccountRouteName: string;
  // Route name for the BU invest page (free-plan redirect).
  investRouteName: string;
  // Help center URL for this BU (shown in sidebar support links).
  helpCenterUrl: string;
  // Whether the BU requires a plan-subscription-approval modal before checkout.
  hasPlanSubscriptionApproval: boolean;
  // i18n key for the BU description on the chooser page.
  chooserDescriptionKey: string;
  // Orbit entity kind for admin deep links.
  orbitEntityType: 'ecommerce' | 'project';
  // Orbit path template for admin deep links.
  orbitPathTemplate: string;
  // Shared UI assets resolved by BU.
  logoPath: string;
  faviconPath: string;
}

export const BUSINESS_UNITS: BusinessUnitConfig[] = [
  {
    key: BusinessUnitKey.Flokee,
    label: 'Flokee',
    basePath: '/flokee',
    // Domain routing only applies in production.
    domain: import.meta.env.VITE_APP_FLOKEE_URL,
    dashboardRouteName: DEFAULT_DASHBOARD_ROUTE_NAME,
    loginRouteName: DEFAULT_LOGIN_ROUTE_NAME,
    selectAccountRouteName: DEFAULT_SELECT_ACCOUNT_ROUTE_NAME,
    investRouteName: 'InvestView',
    helpCenterUrl: 'https://help.flokee.ai/introduccion',
    hasPlanSubscriptionApproval: true,
    chooserDescriptionKey: 'common.choose_business_unit_flokee_description',
    orbitEntityType: 'ecommerce',
    orbitPathTemplate: '/flok/ecommerce/:id/info',
    logoPath: '/images/logo.svg',
    faviconPath: '/favicon/favicon-flokee.ico',
  },
  {
    key: BusinessUnitKey.Cleepo,
    label: 'Cleepo',
    basePath: '/cleepo',
    domain: import.meta.env.VITE_APP_CLEEPO_URL,
    dashboardRouteName: 'CleepoDashboardView',
    loginRouteName: 'CleepoAuthLoginView',
    selectAccountRouteName: 'CleepoSelectAccountView',
    investRouteName: 'CleepoInvestView',
    helpCenterUrl: 'https://help.engeni.com/es/collections/15832894-cleepo',
    hasPlanSubscriptionApproval: false,
    chooserDescriptionKey: 'common.choose_business_unit_cleepo_description',
    orbitEntityType: 'project',
    orbitPathTemplate: '/cleepo/project/:id/info',
    logoPath: '/images/cleepo-logo-green-blue.png',
    faviconPath: '/favicon/favicon-cleepo.ico',
  },
];

export function getBusinessUnitConfig(key_value: BusinessUnitKey | undefined) {
  if (!key_value) return undefined;
  return BUSINESS_UNITS.find((bu) => bu.key === key_value);
}
